import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { CircularProgress } from '@mui/material';
import { DoughnutChartStyles } from './Style'
import { ratingColors4, ratingListLabel } from 'keys/rating';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend,
    // ChartDataLabels
);

const options = {
    responsive: true,
    plugins: {
        datalabels: {
            display: false, // Hide labels for this Bar component
        },
        legend: {
            display: false,
        },
        // datalabels: {
        //     anchor: 'center',
        //     align: 'center',
        //     offset: 20,
        //     formatter: (value, context) => {
        //         return `${value.toFixed(0)}%`;
        //     }
        // },
        title: {
            display: false,
        },
        tooltip: {
            titleAlign: "center",
            bodyAlign: "center",
            footerAlign: "center",
            displayColors: false,
            callbacks: {
                label: function ({ formattedValue }) {
                    return !formattedValue || `${Number(formattedValue)?.toFixed(0)}%`
                },
                labelPointStyle: () => ({ display: "none" }),
                labelPointStyle: () => ({ textAlign: "end" })
            }
        }
    },
};

const ChartComponent = (props) => {
    const { data, loading, ratingColors } = props

    const datasets = {
        label: '# of Votes',
        backgroundColor: ratingColors || ratingColors4,
        borderColor: ratingColors || ratingColors4,
        borderWidth: 1
    }

    return (
        <DoughnutChartStyles>
            {!loading ?
                data ?
                    <Doughnut
                        data={{
                            labels: ratingListLabel,
                            datasets: [{
                                ...datasets,
                                data: data
                            }]
                        }}
                        options={options}
                    /> : "אין עדיין תוצאות"
                :
                <CircularProgress color="thirdly" />}
        </DoughnutChartStyles>
    );
};

export default ChartComponent;